import React, {useState} from 'react';
import {postToHub} from "../../network/actions";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {RadioButton} from "primereact/radiobutton";
import {InputNumber} from "primereact/inputnumber";

function ClearMessagesModal(props) {
    const [ deleteType, setDeleteType ] = useState("");
    const [ confirmDelete, setConfirmDelete ] = useState("");
    const [ cabinNr, setCabinNr ] = useState("");
    const [ cabinError, setCabinError ] = useState("");
    const [ nrDeleted, setNrDeleted ] = useState(null);

    const handleDelete = async () => {
        // POST to hub to clear mesasages, show toast and close modal
        const deleteAll = confirmDelete === "all";
        const payload = {
            broadcastToAllDecks: deleteAll,
        }

        if(!deleteAll) {
            payload.cabinNumbers = cabinNr;
        }

        const result = await postToHub("cabinmessage/clear", payload);
        if(result && result.totalMessagesCleared !== undefined) {
            setConfirmDelete("");
            setNrDeleted(result.totalMessagesCleared);
        }
    }

    const validateCabinNr = () => {
        if(cabinNr === "" || !parseInt(cabinNr)) {
            setCabinError("Please select a cabin");
        }
        else {
            setCabinError("");
            setNrDeleted(null);
            setConfirmDelete("single")
        }
    }

    const changeDeleteType = (e) => {
        setDeleteType(e.value);
        setConfirmDelete("");
    }

    return (
        <Dialog
            visible={true}
            header="Clear messages"
            style={{ width: '60vw' }}
            footer={(<Button label="Close" icon="pi pi-times" onClick={() => {props.setShowDeleteModal(false);}} text />)}
            onHide={() => {props.setShowDeleteModal(false)}}
        >
            <div>
                <div>Please select which messages you would like to clear:</div>
                <div className="flex my-4">
                    <div className="">
                        <label>
                            <RadioButton name="messagefor" value="cabin" onChange={changeDeleteType} checked={deleteType === 'cabin'} />
                            <span className="ml-2">
                                A single cabin
                            </span>
                        </label>
                    </div>
                    <div className="ml-12">
                        <label className="ml-2">
                            <RadioButton name="messagefor" value="all" onChange={changeDeleteType} checked={deleteType === 'all'} />
                            <span className="ml-2">
                                All cabins
                            </span>
                        </label>
                    </div>
                </div>

            </div>
            {deleteType === "cabin" &&
            <div>
                <label> Cabin number
                    <InputNumber className="ml-4 w-16 inline-block"
                               value={cabinNr} useGrouping={false}
                                 onChange={(e) => setCabinNr(e.value)}/>
                </label>
                <Button className="ml-4" label="Delete messages for cabin" onClick={validateCabinNr}/>
                {cabinError &&
                    <div className="text-red-700 mt-4">
                        {cabinError}
                    </div>
                }
            </div>
            }

            {deleteType === "all" &&

            <div className="mt-8">
                <Button label="Delete ALL messages" onClick={() => {setConfirmDelete("all"); setNrDeleted(null)}}/>
            </div>
            }
            {confirmDelete &&
                <div className="mt-8">
                    <div className="my-4">
                        You are about to delete ALL messages for {confirmDelete === "all" ? "ALL cabins" : `cabin ${cabinNr}`}. Are you sure?
                    </div>
                    <div>
                        <Button severity='danger' label="Yes - delete" onClick={handleDelete}/>
                        <Button className="ml-16" label="No" onClick={() => setConfirmDelete("")}/>
                    </div>
                </div>
            }
            {nrDeleted !== null &&
                <div className="mt-8">
                    Delete operation was successful. {nrDeleted} messages were deleted.
                </div>
            }
        </Dialog>
    )
}
export default ClearMessagesModal;